import { render, staticRenderFns } from "./ListaReporte.vue?vue&type=template&id=130f7467"
import script from "./ListaReporte.vue?vue&type=script&lang=js"
export * from "./ListaReporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports